module.exports = __webpack_public_path__ + "media/images/shop-register-bg_old-b80b0fe134983c4e507bba25f7ca3e22.jpg";